angular.module('workflow.app')

.factory( 'SearchWorker', ( Model, Api, SearchResults, StepConfigSource, numberSuffixFilter ) ->

  class SearchWorker extends Model
    COUNTER_ACCURACY =
      OVERESTIMATE: "OVERESTIMATE"
      EXACT: "EXACT"

    isRunning: ->
      @state == 'RUNNING'

    hasFinished: ->
      not @isRunning()

    hasFailed: ->
      @state == 'FAILED'

    isAcceptingResults: ->
      @state == "ACCEPTING_RESULTS"

    getResultsCount: ->
      @results_available or 0

    getResultsCountEstimateType: ->
      if @isFactivaParser()
        return COUNTER_ACCURACY.OVERESTIMATE
      return COUNTER_ACCURACY.EXACT

    getResultsDisplayCount: ->
      if @getResultsCountEstimateType() == COUNTER_ACCURACY.OVERESTIMATE
        if not @results_available
          return "0"
        else if @results_available < 100
          return @results_available.toString()
        else if @results_available < 200
          return "<200"
        else if @results_available < 500
          return "<500"
        else if @results_available < 1000
          return "<1000"
        else if @results_available >= 1000
          return ">1000"
      else
        return numberSuffixFilter(@results_available || 0)

    getFilteredResultsCount: ->
      (@results_retrieved or 0) - @getResultsCount()

    hasResults: ->
      @hasFinished() and @getResultsCount() > 0

    hasFilteredResults: ->
      @hasFinished() and @getFilteredResultsCount() > 0

    queryResults: ( limit, offset, prefetch_next_page = "true") ->
      SearchResults.query(
        { worker: @.id, limit: limit, offset: offset, prefetch_next_page }
      )

    getType: ->
      @type

    getName: ->
      @name

    getPrimaryKey: ->
      @pk

    isKraken: ->
      @getType() == 'krakenworker'

    isAsync: ->
      @getType() == 'asyncsearchworker'

    isElasticSearch: ->
      @getType() == 'elasticsearchworker'

    isWebSearch: ->
      # In the past we were using the BingSearch engine, which was using this BingSearch
      # workers. This particular worker was using BingSearch V2, which is no longer
      # available and its integration was removed from our search-service library.
      # Now we have been searching Bing through a DataIntegrationSearch engine instead.
      #
      # This was left here just as reference to the legacy contents in the database.
      @getType() is 'googlecustomsearchworker' or @getType() is 'bingsearchworker' or @getType() is 'bingwebworker'

    isIntegration: ->
      not ( @isKraken() or @isElasticSearch() or @isWebSearch() )

    isAsyncNotSearched: ->
      @isAsync() and @results_available is null

    isNewsSearch: ->
      # @Roey: No better way. The @facets?.sources? is to distinguish merged news/factiva
      @name.toLowerCase().indexOf('news') > -1 and @facets?.sources?

    hasSnapshot: ->
      @kraken_snapshot?

    hasDateFilter: ->
      @from_date? or @to_date?

    alwaysShowDateFilter: ->
      @engine?.always_show_date_filter

    isFactivaSoap: ->
      factiva_data_integrations = ['factiva_soap', 'factiva_soap_language_filter', 'factiva_soap_most_recent_decade']
      @engine?.integration_type in factiva_data_integrations

    isFactivaSoapLanguageFilter: ->
      @engine?.integration_type == 'factiva_soap_language_filter'

    isFactivaParser: () ->
      @engine?.integration_type == 'factiva_parsers'

    isFactiva: ->
      @getType() == 'factivasearchworker' or @isFactivaSoap()

    isPythia: ->
      @engine?.integration_type == 'pythia_entity_search'

    isPaid: ->
      @engine?.access_restriction == 'paid'

    isWisers: ->
      @getType() == 'wiserssearchworker'

    isLexisNexis: ->
      @getType() == 'lexisnexisnewsworker'

    isVlex: ->
      @engine?.integration_type == 'vlex'

    isAccuity: ->
      @engine?.integration_type?.indexOf('accuity') == 0

    isThomsonReuters: ->
      @engine?.integration_type == 'trma'

    isWorldCheck: ->
      @engine?.integration_type == 'worldcheck'

    isWorldCompliance: ->
      @engine?.integration_type?.indexOf('worldcompliance') == 0

    isBvD: ->
      @getType() == 'bvdsearchworker' or @engine?.integration_type == 'bvd_new'

    isUSS: ->
      @engine?.integration_type == 'uss_search'

    isNewsSearchViaUSS: ->
      @isUSS and @engine?.integration_configuration?.source == 'arachnys.news'

    isNLPNewsSearchViaUSS: ->
      @isUSS and @engine?.integration_configuration?.source == 'arachnys.nlp_news'

    requiresLogin: ->
      @engine?.access_restriction == 'login'

    getLogoUrl: ->
      @engine?.logo_url

    updateResultsCount: ->
      self = @
      Api.SearchWorker.get( { id: @id } ).$promise.then ( worker ) ->
        self.results_available = worker.results_available

    updateResultsAvailable: ->
      if @results_available is null
        Api.SearchWorker.update( { id: @id }, { results_available: 0 } )

    hasSource: ->
      return @engine?

    getSource: ->
      return new StepConfigSource( @engine )

)
